import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit"
import NetworkManager from "../../app/managers/networkManager"
import { config } from "../../app/utils/config"
import teletravailIcon from "../../assets/images/teletravail.png"
import deplacementIcon from "../../assets/images/deplacement.png"
import voitureIcon from "../../assets/images/voiture.png"
import { locale } from 'primereact/api'
import moment from "moment"
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers"

// Postes that must never be deleted from the settings screens.
// The backend (TeamsController.removePoste) enforces the same list.
export const PROTECTED_POSTE_IDS = [248]

const initialState = {
  lang: localStorage.getItem("lang"),
  holidays: {},
  companies: [],
  settingsList: {},
  localSettingsList: {},
  selectedSettingsList: [],
  blockageDay: null,
  isMobile: 1,
  parameters: {
    base_horaire_hebdo: 35,
    base_horaire_mensuelle: 151.67,
    heure_debut_journee: 6,
    heure_fin_journee: 21,
    majoration_heures_nuit: 0.5,
    taux_heures_supp: 1.25,
    taux_heures_samedi: 1.25,
    taux_heures_dimanche: 2,
    taux_heures_ferie: 1,
    taux_heures_samedi_ferie: 2,
    taux_heures_dimanche_ferie: 2,
    taux_heures_1mai: 2,
    taux_heures_samedi_1mai: 2,
    taux_heures_dimanche_1mai: 2,
  },
  selectedYear: new Date().getFullYear(),
  leavesColors: [
    "#BBFDBB",
    "#CCFDE9",
    "#B9E1FC",
    "#BADEEE",
    "#BBAFF9",
    "#F3B2EE",
    "#F3B2D5",
    "#F4BCB2",
    "#F9D8B4",
  ],
  shiftColors: [
    "#d6ebff",
    "#B9E1FC",
    "#BADEEE",
    "#d6d7ff",
    "#BBAFF9",
    "#bcbdf9",
    "#F3B2EE",
    "#ffd6eb",
    "#F3B2D5",
    "#fff5d6",
    "#ffe6cc",
    "#feddc7",
    "#fcc39b",
    "#f6de95",
    "#caf1d8",
    "#e4ffd9",
    "#BBFDBB",
    "#ADE6BA",
    "#d6fff5",
    "#CCFDE9",
    "#c7eeea",
    "#9ae0d9",
    "#6dd3c8",
    "#94e0ed"
  ],
  groupesColors: [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#3f51b5",
    "#2196f3",
    "#03a9f4",
    "#00bcd4",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#cddc39",
    "#ffc107",
    "#ff5722",
    "#795548",
    "#607d8b"
  ],
  shiftTypes: [
    {
      value: "p",
      label: "inSitu",
      // color: "#D9D9D9",
      roleId: 3
    },
    {
      value: "t",
      label: "Télétravail",
      color: "#f76808",
      icon: teletravailIcon,
      roleId: 3
    },
    {
      value: "v",
      label: "Déplacement",
      color: "#8e4ec6",
      icon: deplacementIcon,
      roleId: 3
    },
    {
      value: "f",
      label: "Déplacement avec Voiture Groupe Vital",
      color: "#a5326b",
      icon: voitureIcon,
      roleId: 3
    },
    {
      value: "R",
      label: "Repos",
      roleId: 2
    },
    {
      value: "AST",
      label: "Astreinte",
      color: "var(--blue-400)",
      roleId: 2
    },
    {
      value: "INT_AST",
      label: "Intervention Astreinte",
      color: "var(--blue-400)",
      roleId: 3
    }
  ],
  postes: [],
  countries: [],
  selectedCountry: null
}

export const getHolidays = createAsyncThunk(
  "planning/getHolidays",
  async ({ year, idCountry }) => {
    try {
      let getURL = config.apiPaths.planning.getHolidays + `?year=${year}`
      if (idCountry) getURL += `&idCountry=${idCountry}`
      let response = await NetworkManager.getInstance().getRequest(
        getURL
      )
      return response
    } catch (error) {
      return error
    }
  }
)

export const getSettings = createAsyncThunk(
  "planning/getSettings",
  async () => {
    try {
      let response = await NetworkManager.getInstance().getRequest(
        config.apiPaths.planning.getSettings
      )
      return response
    } catch (error) {
      return error
    }
  }
)

export const updateSettings = createAsyncThunk(
  "planning/updateSettings",
  async (body) => {
    try {
      let response = await NetworkManager.getInstance().postRequest(
        config.apiPaths.planning.updateSettings,
        body
      )
      return response
    } catch (error) {
      return error
    }
  }
)

export const updateTeamSettings = createAsyncThunk(
  "planning/updateTeamSettings",
  async (body) => {
    try {
      let response = await NetworkManager.getInstance().postRequest(
        config.apiPaths.planning.updateTeamSettings,
        body
      )
      return response
    } catch (error) {
      return error
    }
  }
)

export const getPostesSettings = createAsyncThunk(
  "teams/getPostesSettings",
  async (body) => {
    try {
      let response = await NetworkManager.getInstance().postRequest(
        config.apiPaths.teams.getPostesSettings,
        body
      )
      return response
    } catch (error) {
      return error
    }
  }
)
export const addEditPoste = createAsyncThunk(
  "teams/addEditPoste",
  async (body) => {
    try {
      let response = await NetworkManager.getInstance().postRequest(
        config.apiPaths.teams.addEditPoste,
        body
      )
      return response
    } catch (error) {
      return error
    }
  }
)
export const removePoste = createAsyncThunk(
  "teams/removePoste",
  async (body) => {
    try {
      let response = await NetworkManager.getInstance().postRequest(
        config.apiPaths.teams.removePoste,
        body
      )
      return response
    } catch (error) {
      return error
    }
  }
)
export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload
      localStorage.setItem("lang", action.payload)
      locale(action.payload)
      moment.locale(action.payload)
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload
    },
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload
      Object.keys(state.settingsList).map(k => {
        state.localSettingsList[k].settingValue = state.settingsList[k].settingValue
      })
      if (action.payload.settings && action.payload.settings.length) {
        action.payload.settings.map(s => {
          state.localSettingsList[s.id_setting].settingValue = s.value
        })
      }
    },
    setParameters: (state, action) => {
      state.parameters = action.payload
    },
    setLocalSettings: (state, action) => {
      state.localSettingsList[action.payload["id"]].settingValue = action.payload["value"]
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getHolidays.fulfilled, (state, action) => {
      if (action.payload.responseData && action.payload.responseData.year) {
        state.holidays[action.payload.responseData.year] = {}
        if (!state.holidays) 
          state.holidays = {}
        state.holidays[action.payload.responseData.year] = action.payload.responseData.holidays
      }
    })
    builder.addCase(getSettings.fulfilled, (state, action) => {
      if (action.payload.responseData) {
        if (action.payload.responseData["settings"]) {
          state.settingsList = {}
          state.localSettingsList = {}
          for (const key in action.payload.responseData["settings"]) {
            let setting = action.payload.responseData["settings"][key]
            if (setting["label"] == "Jour du mois de blocage") {
              state.blockageDay = setting["value"]
            }
            let defaultSetting = {
              value: setting["id"],
              id: setting["id"],
              id_role: setting["id_role"],
              label: setting["label"],
              settingValue: setting["value"],
              type: setting["type"],
              min: setting["min"],
              max: setting["max"]
            }
            state.settingsList[setting["id"]] = defaultSetting
            state.localSettingsList[setting["id"]] = Object.assign({}, defaultSetting)
          }
          state.selectedSettingsList = []
        }
        if (action.payload.responseData["companies"]) {
          let companiesList = []
          for (const key in action.payload.responseData["companies"]) {
            let company = action.payload.responseData["companies"][key]
            companiesList.push({
              value: company["id"],
              label: `${company["name"]}, ${company["localization"]}`
            })
          }
          state.companies = companiesList
        }
        if (action.payload.responseData["countries"]) {
          state.countries = []
          for (const key in action.payload.responseData["countries"]) {
            let country = action.payload.responseData["countries"][key]
            state.countries.push({
              value: country["id"],
              label: country["country_name"],
              settings: country["settings"]
            })
            if (state.selectedCountry && state.selectedCountry.value == country["id"]) {
              country["settings"].map(s => {
                state.localSettingsList[s.id_setting].settingValue = s.value
              })
            }
          }
        }
      }
    })
    builder.addCase(updateSettings.fulfilled, (state, action) => {
      console.log("Settings updated successfully");
      if (action.payload.responseData && action.payload.responseData.status) {
        showSuccessToast("Settings updated successfully")
      } else {
        showErrorToast("Quelque chose s'est mal passé !")
      }
    })
    builder.addCase(updateTeamSettings.fulfilled, (state, action) => {
      console.log("Team Settings updated successfully");
    })
    builder.addCase(getPostesSettings.fulfilled, (state, action) => {
      if (action.payload.responseData) {
        state.postes = action.payload.responseData.postes
      }
    })
  },
})

export const {
  setLanguage,
  setSelectedYear,
  setParameters,
  setLocalSettings,
  setIsMobile,
  setSelectedCountry
} = settingsSlice.actions

export default settingsSlice.reducer
